import { render, staticRenderFns } from "./SmartBriefNews.vue?vue&type=template&id=84e18dee&"
import script from "./SmartBriefNews.vue?vue&type=script&lang=js&"
export * from "./SmartBriefNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports